<template>
  <div>Mail Order Page</div>
</template>

<script>
export default {};
</script>

<style></style>
